module.exports = __webpack_public_path__ + "static/media/voltage.5eb17961.png";